<template>
  <div class="shortcast-audio">
    <audio-player
      :audio-url="audioUrl"
      :has-volume="false"
      :has-progress-thumb="false"
      :reset-on-end="true"
      :has-time="false"
      block-name="shortcast-audio-player"
      event-name="body-202100602-shortcast_audio_player"
      ref="player"
      @play="onPlay"
      @ended="onEnded"
    />
    <div class="shortcast-audio__label">
      {{ $t("label") }}
    </div>
  </div>
</template>

<script>
import AudioPlayer from "@/shared/audio-player/audio-player.vue"
import backendEvents from "@/api/backend-events"

export default {
  name: "ShortcastAudioPlayer",
  components: { AudioPlayer },
  props: {
    audioUrl: { type: String, default: null },
    shortcast: {
      type: Object,
      required: true
    },
    episode: {
      type: Object,
      required: true
    }
  },
  i18n: {
    messages: {
      en: {
        label: "Listen to the whole episode"
      },
      de: {
        label: "Ganze Folge anhören"
      }
    }
  },
  methods: {
    onPlay() {
      backendEvents.create(this.eventBody("ShortcastEpisodePlayTapped")).catch(() => {
        // no-op
      })
    },
    onEnded() {
      backendEvents.create(this.eventBody("ShortcastEpisodeFinished")).catch(() => {
        // no-op
      })
    },
    eventBody(actionName) {
      return {
        category: "shortcasts",
        action: actionName,
        version: "20210625",
        /* eslint-disable camelcase */
        custom_variables: {
          shortcast_slug: this.shortcast.slug,
          episode_id: parseInt(this.episode.id),
          url: `/shortcasts/${this.shortcast.slug}/${this.episode.id}`
        }
        /* eslint-enable camelcase */
      }
    }
  }
}
</script>

<style lang="scss">
.shortcast-audio {
  position: relative;

  &__label {
    @include font-family(sans-serif);
    @include font-style(caption, $color: $dark-grey);

    position: absolute;
    top: $spacing-4;
    left: rem(80px);
  }
}

.shortcast-audio-player {
  $root: &;

  @include font-family(sans-serif);

  display: flex;
  align-items: center;

  &__element {
    &--play {
      width: $spacing-64;
      height: $spacing-64;
      margin-right: $spacing-16;
    }

    &--progress {
      flex-grow: 1;
      margin-right: $spacing-8;
    }

    &--time {
      margin-right: $spacing-8;

      color: $black;
    }

    &--total {
      color: $black;

      @include media(max-width, m) {
        padding-right: 0;
      }
    }

    &:not(&--play) {
      margin-top: $spacing-16;
    }
  }

  &__play {
    display: block;

    width: 100%;
    height: 100%;

    background-image: url("~@images/shortcast-episode-player/play-filled-midnight.svg");
    background-repeat: no-repeat;
    background-size: cover;

    cursor: pointer;
  }

  &__pause {
    background-image: url("~@images/shortcast-episode-player/pause-filled-midnight.svg");
  }

  &__remaining-time {
    min-width: 3em;
  }

  &__progress {
    width: 100%;
  }

  &__volume {
    width: 100%;
  }

  .ranger {
    &__path {
      height: 5px;

      background: $lightest-grey;
    }
  }
}
</style>
